import { fireLinkTag } from './tagManager';

/**
 * TODO pass in string so we dont specify pdp in this common repo
 * @param {boolean} isOpen
 */
export function tagColorExpandableListToggle(isOpen) {
  const eventName = isOpen
    ? 'pdp see more color expand'
    : 'pdp see more color collapse';

  fireLinkTag({ event_name: eventName });
}

export default tagColorExpandableListToggle; // temp, until we add more functions
